//import './wdyr'; // <--- first import

import React from 'react';
import ReactDOM from 'react-dom';

import './index.css?ver=1';
import App from './App?ver=1';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import * as AppUrls from "./constants/AppUrls";

/* import './assets/fonts/Source_Sans_Pro/SourceSansPro-Italic.ttf' */

import "./i18n";
import { Provider } from 'react-redux';
import store from "./store/store";




const app = (
  <BrowserRouter basename={AppUrls.basename}>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <App i18n={i18n} />
      </I18nextProvider>
    </Provider>
  </BrowserRouter>
);

ReactDOM.render(
  app,
  document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
